<template>
  <div class="hall-of-honor">
    <img class="bg" src="./images/bg3.png" alt="" />
    <div class="dressup-list-box">
      <div class="dressup-list-item" v-for="(item, index) of list" :key="index">
        <div
          class="dressup-item"
          v-for="(subItem, subIndex) of item"
          :key="subIndex"
        >
          <img :src="subItem" alt="" />
        </div>
      </div>
    </div>
    <template v-if="activityEnd">
      <div class="top3-box">
        <div
          v-for="(item, index) of topList"
          :key="item.userUuid"
          class="item"
          :class="`top${index + 1}`"
        >
          <img
            :src="item.avatarUrl"
            class="head-portrait"
            @click="toPlayerDetail(item.userUuid)"
          />
          <div class="user-name">{{ item.nickname }}</div>
        </div>
      </div>
      <div class="score-board-box" @scroll.stop>
        <div
          class="item"
          v-for="item of userList.slice(3, 8)"
          :key="item.userUuid"
        >
          <img
            :src="item.avatarUrl"
            alt="頭像"
            class=""
            @click="toPlayerDetail(item.userUuid)"
          />
          <span class="user-name">{{ item.nickname }}</span>
        </div>
      </div>
    </template>
    <template v-if="!activityEnd">
      <div class="top3-box">
        <div v-for="i in 3" :key="i" class="item" :class="`top${i}`">
          <img
            src="https://resource.3uplay.com/3uplay/avatar/img-defaultUser-min.png?d=100x100"
            class="head-portrait"
          />
          <div class="user-name">敬請期待</div>
        </div>
      </div>
      <div class="score-board-box" @scroll.stop>
        <div class="item" v-for="item in 5" :key="item">
          <img
            src="https://resource.3uplay.com/3uplay/avatar/img-defaultUser-min.png?d=100x100"
            class="head-portrait"
          />
          <div class="user-name">敬請期待</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'HallOfHonor',
  props: {
    honorData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [
        [
          'https://resource.3uplay.com/sys-feed/9092df09-88c2-4fa7-9f7c-88593ff561d7833659644288249844.webp',
          'https://resource.3uplay.com/sys-feed/ec770bc1-cdba-4c0f-b562-086b6d9d288d6957100221576210235.webp',
          'https://resource.3uplay.com/sys-feed/3cfd8c2f-5d73-48e1-8e88-f0e3b9c10e971067842923577449852.webp'
        ],
        [
          'https://resource.3uplay.com/sys-feed/69e0011a-dfe9-4081-aefa-57dbef9981fb1124565022421474285.webp',
          'https://resource.3uplay.com/sys-feed/514a8b1f-192a-486b-86f6-d4b94822ed527270109139383719709.webp',
          'https://resource.3uplay.com/sys-feed/fcf3a2f7-3a9d-48be-b2db-6bc2a3bb220c615631914880930637.webp'
        ],
        [
          'https://resource.3uplay.com/sys-feed/03c172e6-1315-45ae-9721-c195098b47258823305160634840776.webp',
          'https://resource.3uplay.com/sys-feed/b0cef111-10d0-4e9e-8099-49fb90b79f91175426160780983767.webp',
          'https://resource.3uplay.com/sys-feed/ee748495-7199-4537-8bb6-024a65b816933600806953813971002.webp'
        ],
        [
          'https://resource.3uplay.com/sys-feed/c274485c-13c7-4a79-a95b-8bf46fa6b3a13414236671133890700.webp',
          'https://resource.3uplay.com/sys-feed/aa97749c-c5de-473e-b050-a1ce8bc07fa76909747037401931853.webp',
          'https://resource.3uplay.com/sys-feed/6423e4f3-0e5a-49f8-8c2a-90b5fb7dd14c7031019583513072761.webp'
        ],
        [
          'https://resource.3uplay.com/sys-feed/c274485c-13c7-4a79-a95b-8bf46fa6b3a13414236671133890700.webp',
          'https://resource.3uplay.com/sys-feed/aa97749c-c5de-473e-b050-a1ce8bc07fa76909747037401931853.webp',
          'https://resource.3uplay.com/sys-feed/6423e4f3-0e5a-49f8-8c2a-90b5fb7dd14c7031019583513072761.webp'
        ]
      ],
      activityEnd: new Date() > new Date(2024, 0, 27)
    };
  },
  watch: {},
  computed: {
    userList() {
      return this.honorData ? this.honorData.NewYearStage3EndDate || [] : [];
    },
    topList() {
      return this.userList && this.userList.length
        ? [this.userList[1], this.userList[0], this.userList[2]]
        : [];
    }
  },
  methods: {
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.hall-of-honor {
  width: 100%;
  position: relative;
  font-size: 0;
  > .bg {
    width: 100%;
    max-width: 100%;
  }
  .dressup-list-box {
    position: absolute;
    width: 100%;
    z-index: 2;
    top: 794px;
    left: 0;
    padding: 0 0 0 74px;
    // border: 1px solid yellow;
  }
  .dressup-list-item {
    display: flex;
    margin-bottom: 1253px;

    &:nth-child(1) {
      margin-bottom: 1253px;
    }
    // &:nth-child(2) {
    //   margin-bottom: 1420px;
    // }
    // &:nth-child(3) {
    //   margin-bottom: 1420px;
    // }
    &:nth-child(4) {
      margin-bottom: 825px;
    }
    // &:nth-child(5) {
    //   margin-bottom: 708px;
    // }
  }
  .dressup-item {
    // border: 1px solid yellow;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 255px;
    height: 227px;
    margin-right: 32px;

    img {
      width: 167px;
      height: auto;
      // margin-bottom: 53px;
    }
  }
  .top3-box {
    position: absolute;
    top: 7274px;
    display: flex;
    left: 56px;
    justify-content: space-around;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      font-size: 24px;
      flex: none;
      color: black;
      width: 257px;
      margin-right: 45px;
      color: white;

      .btn-item {
        // position: absolute;
        width: dPx(60);
        height: dPx(24);
        margin-top: 40px;
      }
      img {
        border-radius: 50%;
        object-fit: cover;
        width: dPx(58);
        height: dPx(58);
        border: 3px white solid;
      }
      .user-name,
      .score {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        text-align: center;
      }
      .user-name {
        padding: 0 12px;
        margin-top: 103px;
        @include ellipsis;
      }
      .score {
        margin-top: dPx(5);
        font-size: 16px;
      }
      &.top1,
      &.top3 {
        margin-top: 90px;
      }
    }
  }
  .score-board-box {
    display: flex;
    width: calc(100% - 100px);
    overflow: auto;
    flex-wrap: nowrap;
    margin: 0 50px;
    position: absolute;
    top: 7773px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      width: dPx(88);
      height: dPx(101);
      overflow: hidden;
      flex: none;
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url('./images/honor-rank-bg.png') no-repeat center center;
      background-size: 100% 100%;
    }
    img {
      border-radius: 50%;
      object-fit: cover;
      width: dPx(58);
      height: dPx(58);
      border: 3px white solid;
      margin-top: 24px;
    }
    .user-name {
      color: white;
      font-size: dPx(12);
      display: inline-block;
      width: dPx(58);
      @include ellipsis;
      margin-top: 20px;
    }
  }
}
</style>
